var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),_c('transition',{attrs:{"name":"fadeInUp","mode":"out-in"}},[(_vm.notis && _vm.notis.length>0)?_c('div',{attrs:{"id":"noti-cont"}},_vm._l((_vm.notis),function(noti){return _c('div',{key:noti.msg},[_vm._v(_vm._s(noti.msg))])}),0):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }